<template>
  <v-container
    id="eligibilityEdit"
    class="pa-0"
  >
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-resource-select
          label="Product"
          item-text="product"
          item-value="id"
          bind-text="product"
          bind-value="productId"
          :bind-item="editedItem"
          :error-messages="formErrors.ProductId"
          :resource="productResource"
          :disabled="disabled"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-resource-select
          label="Carrier"
          item-text="carrier"
          item-value="id"
          bind-text="carrier"
          bind-value="carrierId"
          :bind-item="editedItem"
          :error-messages="formErrors.CarrierId"
          :resource="carrierResource"
          :disabled="disabled"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <base-resource-select
          label="Eligibility Group"
          item-text="eligibilityGroup"
          item-value="id"
          bind-text="eligibilityGroup"
          bind-value="oeEligibilityGroupId"
          :bind-item="editedItem"
          :error-messages="formErrors.OEEligibilityGroupId"
          :fetch-method="getEligibilityGroup"
          :disabled="disabled"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.retroactiveEnrollmentsAllowed"
          :error-messages="formErrors.RetroactiveEnrollmentsAllowed"
          :disabled="disabled"
          label="Retroactive Enrollments Allowed"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.eligibleForCoverage"
          :error-messages="formErrors.EligibleForCoverage"
          :disabled="disabled"
          label="Domestic Partners Allowed"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.cobraEligible"
          :error-messages="formErrors.COBRAEligible"
          :disabled="disabled"
          label="COBRA Eligible"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.minHours"
          :error-messages="formErrors.MinHours"
          :disabled="disabled"
          label="Min Hours"
          type="number"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.waitingPeriod"
          :error-messages="formErrors.WaitingPeriod"
          :disabled="disabled"
          label="Waiting Period"
          type="number"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.gracePeriod"
          :error-messages="formErrors.GracePeriod"
          :disabled="disabled"
          label="Grace Period"
          type="number"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="editedItem.effectiveMode"
          section="OE Eligibility - Effective Mode"
          :error-messages="formErrors.EffectiveMode"
          :disabled="disabled"
          label="Effective Mode"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-date-picker
          :date-value.sync="editedItem.effectiveDate"
          :error-messages="formErrors.EffectiveDate"
          :disabled="disabled"
          label="Effective Date"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="editedItem.termMode"
          section="OE Eligibility - Term Mode"
          :error-messages="formErrors.TermMode"
          :disabled="disabled"
          label="Term Mode"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="editedItem.taxStatus"
          section="OE Eligibility - Tax Status"
          :error-messages="formErrors.TaxStatus"
          :disabled="disabled"
          label="Tax Status"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.newHiresCanEnrollThroughoutYear"
          :error-messages="formErrors.NewHiresCanEnrollThroughoutYear"
          :disabled="disabled"
          label="New Hires Can Enroll Throughout Year"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.requireDepSSN"
          :error-messages="formErrors.RequireDepSSN"
          :disabled="disabled"
          label="Require Dep SSN"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="editedItem.payrollDeductionMode"
          section="OE Eligibility - Payroll Deduction Mode"
          :error-messages="formErrors.PayrollDeductionMode"
          :disabled="disabled"
          label="Payroll Deduction Mode"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="editedItem.employeeFirstDeductionMode"
          section="OE Eligibility - Employee First Deduction Mode"
          :error-messages="formErrors.EmployeeFirstDeductionMode"
          :disabled="disabled"
          label="Employee First Deduction Mode"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="editedItem.bill"
          section="OE Eligibility - Bill"
          :error-messages="formErrors.Bill"
          :disabled="disabled"
          label="Bill"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.orderNo"
          :error-messages="formErrors.OrderNo"
          :disabled="disabled"
          label="Order"
          type="number"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'EligibilityEdit',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      editedItem: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      errorMessage: null,
      displayError: false,

      eligibilityResource: new TroodyApi('oeEligibility/'),

      productResource: new TroodyApi('product/'),
      carrierResource: new TroodyApi('carrier/'),
      eligibilityGroupResource: new TroodyApi('oeEligibilityGroup/'),
    }),

    methods: {
      getEligibilityGroup () {
        return this.eligibilityGroupResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },

      ensureNumericOrNull (property) {
        const val = this.editedItem[property]
        let nan = (val === null || val === undefined || val === '')

        if (!nan) {
          nan = isNaN(nan)
        }

        if (nan) {
          delete this.editedItem[property]
        } else {
          this.editedItem[property] = Number(val)
        }
      },

      transformItem () {
        this.ensureNumericOrNull('minHours')
        this.ensureNumericOrNull('waitingPeriod')
        this.ensureNumericOrNull('gracePeriod')
        this.ensureNumericOrNull('orderNo')
        this.editedItem.openEnrollmentId = this.openEnrollment.id

        return this.editedItem
      },

      onChange () {
        this.transformItem()
        this.$emit('update:editedItem', this.editedItem)
        this.$emit('change', this.editedItem)
      },
    },
  }
</script>
